import { Box, BoxProps, styled } from '@mui/material';
import { ReactElement, useEffect } from 'react';
import { converter, isExternalUrl } from '@synergy/utils';

const StyledBox = styled(Box)(() => ({
    wordBreak: 'break-word',
    '& > p:first-of-type': {
        marginTop: 0,
    },
    '& > p:last-of-type': {
        marginBottom: 0,
    },
}));

export interface MarkdownConverterProps extends BoxProps {
    value: string;
}

export const MarkdownConverter = (props: MarkdownConverterProps): ReactElement => {
    const { value, ...boxProps } = props;

    useEffect(() => {
        const links = document.querySelectorAll('.markdown-converter a');

        links.forEach(link => {
            link.addEventListener('click', e => {
                e.stopPropagation();
                e.preventDefault();

                const href = link.getAttribute('href');
                if (href && isExternalUrl(href)) {
                    window.open(href, '_blank');
                } else {
                    window.location.href = href || '';
                }
            });
        });

        return () => {
            links.forEach(link => {
                link.removeEventListener('click', e => {
                    e.stopPropagation();
                    e.preventDefault();
                });
            });
        };
    }, [value]);

    return (
        <StyledBox
            {...boxProps}
            className="markdown-converter"
            dangerouslySetInnerHTML={{
                __html: converter.makeHtml(value),
            }}
        />
    );
};
